import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { isBoolean } from 'lodash-es';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { ShFormCheckboxComplexBaseComponent } from '../../form-checkbox/form-checkbox.module';

@Component({
    selector: 'sh-form-toggle-switch-complex-base',
    templateUrl: './form-toggle-switch-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormToggleSwitchComplexBaseComponent)],
    standalone: true,
    imports: [ReactiveFormsModule]
})
export class ShFormToggleSwitchComplexBaseComponent
    extends ShFormCheckboxComplexBaseComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    @Input() description?: string;

    public set(value: boolean | null): void {
        if (!isBoolean(value) || value === null) {
            console.error('ShFormToggleSwitchComplexBaseComponent:: FormValue does not contain a boolean', value);

            this.unset();

            return;
        }

        this.indeterminate$.next(false);

        this.control.setValue(!!value);
    }
}
